import Announcement from './Announcement';
import MonthOfYear from '../../date/MonthOfYear';

export default class KindergartenReport {
    static fromData(data) {
        if (!data) {
            return;
        }

        let report = new KindergartenReport();
        report.id = data.id;
        report.announcements = data.announcements.map(a => Announcement.fromData(a));
        report.inPeriod = MonthOfYear.fromString(data.inPeriod);
        report.created = new Date(data.created);
        report.file = data.file;

        return report;
    }
}
